<script>
export default {
  data() {
    return {
      email: '',
      password: '',
      fn: '',
      ln: '',
      phone: '',
      messenger: '',
      payment_info: '',
      registered: false,
      validators: {
        email: {
          valid: null,
          // eslint-disable-next-line no-useless-escape
          regexp: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          validator: 'email',
        },
        first_name: {
          valid: null,
          regexp: /^[a-zA-Z]{2,}$/,
          validator: 'first_name',
        },
        last_name: {
          valid: null,
          regexp: /^[a-zA-Z -]{3,}$/,
          validator: 'last_name',
        },
        phone: {
          valid: null,
          regexp: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/,
          validator: 'phone',
        },
        messenger: {
          valid: null,
          validator: 'messenger',
          customRegexp: 0,
        },
        payment_order: {
          valid: null,
          validator: 'payment_order',
          customRegexp: 0,
        },
        password: {
          valid: null,
          validator: 'password',
          customRegexp: 3,
        },
      },
    };
  },
  computed: {
    isValid() {
      return Object.keys(this.validators).filter(
        (key) => this.validators[key].valid === true,
      ).length === Object.keys(this.validators).length;
    },
  },
  methods: {
    submit() {
      if (!this.isValid) return;

      const data = {
        email: this.email,
        password: this.password,
        firstname: this.fn,
        lastname: this.ln,
        phone: this.phone,
        messenger: this.messenger,
        payment_info: this.payment_info,
      };

      this.$store.dispatch('REGISTER', data)
        .then(() => {
          this.registered = true;
        })
        .catch((error) => {
          if (error.message === 'Account is not verified') {
            this.registered = true;

            this.$store.dispatch('nt_set_notification', {
              type: 'inform',
              message: 'Your account will be activated soon.',
            });

            return;
          }

          if (error.message === 'Email already exist') {
            this.registered = false;

            this.$store.dispatch('nt_set_notification', {
              type: 'error',
              message: 'This email is already in use. Choose another one.',
            });

            return;
          }

          this.$store.dispatch('nt_set_notification', {
            type: 'error',
            message: 'Unknown error. Please try again.',
          });

          this.registered = false;
        });
    },
    validate(type, value) {
      if (type === 'messenger' || type === 'payment_order' || type === 'password') {
        this.validators[type].valid = value.length > this.validators[type].customRegexp;
        return;
      }

      if (type === 'email') {
        this.validators[type].valid = this.validators[type].regexp.test(
          String(value).toLowerCase(),
        );
        return;
      }

      this.validators[type].valid = this.validators[type].regexp.test(value);
    },
  },
};
</script>
<template src="./register.pug" lang="pug"></template>
<style src="./register.styl" lang="stylus" scoped></style>
